import React from "react";

const SvgChevron = props => <svg fill="none" viewBox="0 0 10 6" {...props}><defs /><path stroke="white" strokeLinecap="square" d="M1 1l4 4 4-4" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMCA2Ij48ZGVmcy8+PHBhdGggc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZD0iTTEgMWw0IDQgNC00Ii8+PC9zdmc+";
export { SvgChevron as ReactComponent };